import React, { useEffect, useState } from "react";
// import { } from '../../MediaConstants/Index';
import Footer from '../../ReuseableComponents/Footer';
import Header from '../../ReuseableComponents/Header';
import HeaderBanner from '../../ReuseableComponents/HeaderBanner';
import '../../Assests/Css/privacy.css';
import { useDispatch } from 'react-redux';
import { staticPagesApi } from "../../Redux/Auth/Auth_Action";

const PrivacyPolicy = () => {

    const [policy, setPolicy] = useState();
    const dispatch = useDispatch();
    const getPolicyData = () => {
        dispatch(staticPagesApi("privacy-policy"))
            .then((res) => {
                // console.log(res.data.response.data[0]);
                setPolicy(res.data.response.data[0]);
            })
            .catch((e) => {
                console.log(e);
            })
    }

    useEffect(() => {
        getPolicyData();
        window.scroll(0, 0);
    }, [])

    useEffect(() => {
        // window.FB.api(
        //     '/me',
        //     'GET',
        //     { "fields": "id,name" },
        //     function (response) {
        //         // Insert your code here
        //         console.log("FACEBOOK RESPONSE", response);
        //     }
        // );

        //  /{page-id}_{post-id}/
        window.FB.api(
            '/100209686175326/feed',
            'GET',
            {
                access_token: 'EAAPudlI7KgIBAKVsiFSzJk1GsZBTZB5dE2ZBbTtGctbO6CpoNFZA7GF6IvMetV6oC6e1EaPRtKejYKmhDvNm1hoTZBLdDJdQZA9dfVibVUba5U5h7ZBN2aqvUMFRv8fWn1sse0V9YOudC6zKXYCzURVclOg01yjnup8I1zx7CQZCaZCLZAZAoHXzYImKZAR8YWA2nzbPrZC9XfNZCkNy75gjZAVZBW4d',
                // attachments: "attachments{full_picture}",
            },
            function (response) {
                // Insert your code here
                console.log("FACEBOOK RESPONSE", response);
            }
        );
    }, []);

    return (
        <div className="TermsAndCondition_Page">
            <Header />
            <HeaderBanner name="Privacy Policy" />
            <section className="privacy_sec">
                <div className="container">
                    <div className="heading_wrapper">
                        <h2>{policy?.page_title}</h2>
                    </div>
                    <div className="content_wrapper text-left" dangerouslySetInnerHTML={{ __html: policy?.content }}>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default PrivacyPolicy;